import React, { FC } from 'react';

import SummaryTopContent from './TopContent';
import SummaryGraphContent from './GraphContent';

const Summary: FC = (): JSX.Element => {
    return (
        <div>
            <SummaryTopContent />
            <SummaryGraphContent />
        </div>
    );
};

export default Summary;
